import { Component, Input, inject } from "@angular/core";
import { HvacService } from "../../core/hvac.service";
import { InterfaceConfiguration } from "../../../../../codegen/out/types";

@Component({
  selector: "app-combined-systems-grid",
  templateUrl: "./combined-systems-grid.component.html",
  styleUrls: ["./combined-systems-grid.component.scss"],
  standalone: false,
})
export class CombinedSystemsGridComponent {
  private hvacService = inject(HvacService);

  @Input() systems: CombinedSystem[];

  columnsToDisplay = [
    "id",
    "manufacturers",
    "thumbnail",
    "modelName",
    "interfaces",
    "actions",
  ];

  getSystemUrl(system: any): string {
    return this.hvacService.getSystemUrl(system.id);
  }
}

export interface CombinedSystem {
  id: string;
  modelName: string;
  manufacturers: string[];
  thumbnail: {
    schematic: {
      url: string;
    };
  };
  interfaceConfigurations: InterfaceConfiguration[];
}
